import { render, staticRenderFns } from "./support-section.vue?vue&type=template&id=4a5d69e6"
import script from "./support-section.vue?vue&type=script&lang=js"
export * from "./support-section.vue?vue&type=script&lang=js"
import style0 from "./support-section.vue?vue&type=style&index=0&id=4a5d69e6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports